import React from 'react';
import { makeStyles, SvgIcon } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  text1: {
    fontSize: theme.spacing(2.5),
    fontWeight: 500,
  },
  text2: {
    fontSize: theme.spacing(2.0625),
  },
}));

const PlatinumFR = props => {
  const { countryCode, ...remainingProps } = props;
  const classes = useStyles();
  return (
    <SvgIcon {...remainingProps} viewBox="0 0 102.99 141.74">
      <defs>
        <radialGradient
          id="radial-gradient"
          cx="20"
          cy="19.26"
          fx="9.490488326355425"
          fy="4.207486599282426"
          r="133.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#747b7d"/>
          <stop offset="0.63" stop-color="#2f2f2f"/>
          <stop offset="0.85"/>
        </radialGradient>
        <radialGradient
          id="radial-gradient-2"
          cx="50.98"
          cy="43.03"
          fx="17.311628041724354"
          fy="19.261078983426607"
          r="113.27"
          gradientTransform="translate(4.12 2.85) rotate(6.28) scale(1 0.81)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#889194"/>
          <stop offset="0.13" stop-color="#838c8f"/>
          <stop offset="0.3" stop-color="#757d7f"/>
          <stop offset="0.48" stop-color="#5f6465"/>
          <stop offset="0.68" stop-color="#3f4142"/>
          <stop offset="0.77" stop-color="#2f2f2f"/>
        </radialGradient>
        <linearGradient
          id="linear-gradient"
          x1="1.82"
          y1="5.93"
          x2="101.17"
          y2="105.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.4" stop-color="#5e5f5f"/>
          <stop offset="0.62" stop-color="#212121"/>
        </linearGradient>
      </defs>
      <g id="shield">
        <path
          fill="url(#radial-gradient)"
          d="M99.35,12.08V89.24a32.37,32.37,0,0,1-12.08,25.28c-5.4,4.36-11,8.65-16.58,12.75-9.56,7-14.6,10.12-19.19,10.12s-9.64-3.12-19.19-10.12c-5.61-4.1-11.19-8.39-16.59-12.75A32.36,32.36,0,0,1,3.65,89.24V12.44c0-1.61,0-3.82.84-4.77S7.56,6.5,9.17,6.35h.16c14-1.32,28.14-2,42.17-2s28.21.66,42.17,2h.15c1.62.15,3.82.36,4.68,1.32S99.35,10.52,99.35,12.08Z"
        />
        <path
          fill="url(#radial-gradient-2)"
          d="M99.35,12.08a5.28,5.28,0,0,0-.62.28c-.79.4-15.82,11.8-33.67,25.42h0l-7.4,5.66C49.09,50,40.26,56.74,32.3,62.84l-9.93,7.62c-10.46,8-17.78,13.7-18,14a3.92,3.92,0,0,0-.67,1v-73c0-1.61,0-3.82.84-4.77S7.56,6.5,9.17,6.35h.16c14-1.32,28.14-2,42.17-2s28.21.66,42.17,2h.15c1.62.15,3.82.36,4.68,1.32S99.35,10.52,99.35,12.08Z"
        />
      </g>
      <path
        fill="url(#linear-gradient)"
        d="M102.45,11.74c0-2.05-.15-4.5-1.63-6.15C99.11,3.68,96.13,3.44,94,3.23q-21.18-2-42.46-2T9,3.23c-2.17.21-5.15.45-6.86,2.36S.53,10.49.53,12.67V89.24a35.6,35.6,0,0,0,13.23,27.7q8.21,6.63,16.7,12.85c9.77,7.14,15.4,10.72,21,10.72s11.27-3.58,21-10.72q8.5-6.22,16.7-12.85a35.6,35.6,0,0,0,13.23-27.7V12.67C102.46,12.37,102.46,12.06,102.45,11.74Zm-3.1,77.5a32.37,32.37,0,0,1-12.08,25.28c-5.4,4.36-11,8.65-16.58,12.75-9.56,7-14.6,10.12-19.19,10.12s-9.64-3.12-19.19-10.12c-5.61-4.1-11.19-8.39-16.59-12.75A32.36,32.36,0,0,1,3.65,89.24V12.44c0-1.61,0-3.82.84-4.77S7.56,6.5,9.17,6.35h.16c14-1.32,28.14-2,42.17-2s28.21.66,42.17,2h.15c1.62.15,3.82.36,4.68,1.32s.85,2.85.85,4.41Z"
      />
      <g id="logo">
        <path
          fill="#fff"
          d="M58.35,87.48A15.3,15.3,0,0,1,66.56,101a1.86,1.86,0,0,1-1.85,1.87H38.3a1.87,1.87,0,0,1,0-3.73H62.66A11.59,11.59,0,0,0,41,95.67a1.87,1.87,0,0,1-3.31-1.73A15.32,15.32,0,0,1,58.35,87.48Z"
        />
        <path
          fill="#fff"
          d="M40.91,106a1.15,1.15,0,0,1,.12.25,11.59,11.59,0,0,0,20.94,0,1.86,1.86,0,0,1,3.36,1.59,15.28,15.28,0,0,1-13.19,8.74H51.5a15.29,15.29,0,0,1-13.83-8.75A1.86,1.86,0,1,1,40.91,106Z"
        />
      </g>
      <text className={classes.text1} fill="#fff" transform="translate(12.71 33.09)">Enphase</text>
      <text className={classes.text2} fill="#fff" transform="translate(10.88 52.56)">
        Installateur<tspan x="8.41" y="17.5">Platinum</tspan>
      </text>
    </SvgIcon>
  );
};

export default PlatinumFR;
